module.exports = "<div class=\"sidebar\">\r\n  <app-sidebar-header></app-sidebar-header>\r\n  <app-sidebar-form></app-sidebar-form>\r\n  <app-sidebar-nav></app-sidebar-nav>\r\n  <app-sidebar-footer></app-sidebar-footer>\r\n  <app-sidebar-minimizer></app-sidebar-minimizer>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/components/app-sidebar/app-sidebar.component.html
// module id = ../../../../../src/app/components/app-sidebar/app-sidebar.component.html
// module chunks = main